module.exports = __webpack_public_path__ + "img/people_with_bunny_ears.e79954f5.gif";